const wipeUploadAssetData = async (clear: () => void) => {
	clear();
};
export default wipeUploadAssetData;
